import AnalyticsPageShell from '../components/analytics/AnalyticsPageShell';
import { useManagerHierarchyContext } from '../contexts/ManagerHierarchyContext';

function ManagerDashboard() {
  const hierarchy = useManagerHierarchyContext();
  return (
    <AnalyticsPageShell
      hierarchy={hierarchy}
      renderMonitorName="ManagerDashboard"
      overviewCacheNamespace="manager"
      landingSubtitle="Activity overviews for your clients"
      emptyClientsMessage="No accessible clients found for your account."
      showUserLevel={false}
    />
  );
}

export default ManagerDashboard;
